import Vue from "vue";
import { Store, Module, ActionContext } from "vuex";
import Vuex from "vuex";
import Ajax from "../../lib/ajax";
Vue.use(Vuex);
import Util from "@/lib/util";
import ProductStatementReportOutput from "@/store/entities/product-statement-report-output";
import EmployeeProductivityReportOutput from "@/store/entities/employee_productivity_report_output";
import DashboardInfoOutput from "@/store/entities/dashboard_info";
import DashboardBacklogOutput from "@/store/entities/dashboard-backlog-output";
import InventoryAgingOutput from "@/store/entities/inventory-aging-output";
import appconst from "./../../lib/appconst";
interface ReportState {
  loading: boolean;
}
class ReportModule implements Module<ReportState, any> {
  namespaced = true;
  state = {
    loading: false,
  };
  actions = {
    async getProductStatementReport(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/Inventory/ProductStatementReport",
        {
          params: payload.data,
        }
      );
      context.state.loading = false;
      return reponse.data.result as ProductStatementReportOutput;
    },
    async exportProductStatement(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      window.open(
        `${appconst.remoteServiceBaseUrl}report/exportProductStatement/` +
          payload.data.clientCode +
          `/` +
          payload.data.warehouseCode +
          `/` +
          payload.data.assetTypeCode +
          `/` +
          payload.data.conditionTypeCode +
          `/` +
          payload.data.sku +
          `/` +
          Util.toReportDateString(payload.data.fromDate) +
          `/` +
          Util.toReportDateString(payload.data.toDate),
        "_blank"
      );
    },
    async getEmployeeProductivityReport(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/Report/EmployeeProductivityReport",
        {
          params: payload.data,
        }
      );
      context.state.loading = false;
      return reponse.data.result as EmployeeProductivityReportOutput;
    },
    async exportEmployeeProductivity(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      window.open(
        `${appconst.remoteServiceBaseUrl}report/exportEmployeeProductivity/` +
          payload.data.warehouseCode +
          `?fromDate=` +
          payload.data.fromDate +
          `&toDate=` +
          payload.data.toDate,
        "_blank"
      );
    },
    async exportPurchasingStatistics(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }report/exportPurchasingStatistics${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
    async exportSalesStatistics(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }report/exportSalesStatistics${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
    async getDashboardReport(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get("/api/services/app/Report/DashboardReport", {
        params: payload.data,
      });
      context.state.loading = false;
      return reponse.data.result as DashboardInfoOutput;
    },
    async getDashboardBacklog(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/Report/DashboardBacklog",
        { params: payload.data }
      );
      context.state.loading = false;
      return reponse.data.result as DashboardBacklogOutput;
    },
    async getInventoryAgingReport(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/Report/InventoryAgingReport",
        { params: payload.data }
      );
      context.state.loading = false;
      return reponse.data.result as InventoryAgingOutput;
    },
    async exportInventoryAgingReport(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }report/exportInventoryAgingReport${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
    async getCustomerStatementReport(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/Inventory/CustomerStatementReport",
        {
          params: payload.data,
        }
      );
      context.state.loading = false;
      return reponse.data.result;
    },
    async exportCustomerStatement(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      window.open(
        `${
          appconst.remoteServiceBaseUrl
        }report/exportCustomerStatementReport${abp.utils.buildQueryString(
          Object.keys(payload.data).map((key) => {
            return {
              name: key,
              value: payload.data[key],
            };
          }),
          true
        )}`,
        "_blank"
      );
    },
    async exportInvoiceSeq(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      var url = `${
        appconst.remoteServiceBaseUrl
      }report/exportInvoiceSeqLine${abp.utils.buildQueryString(
        Object.keys(payload.data).map((key) => {
          return {
            name: key,
            value: payload.data[key],
          };
        }),
        true
      )}`;
      window.open(url, "_blank");
    },
    async exportProducts(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      var url = `${
        appconst.remoteServiceBaseUrl
      }report/ExportProducts${abp.utils.buildQueryString(
        Object.keys(payload.data).map((key) => {
          return {
            name: key,
            value: payload.data[key],
          };
        }),
        true
      )}`;
      window.open(url, "_blank");
    },
    async getCollectionCodeTracking(
      context: ActionContext<ReportState, any>,
      payload: any
    ) {
      context.state.loading = true;
      let reponse = await Ajax.get(
        "/api/services/app/Report/GetCollectionCodeTracking",
        {
          params: payload.data,
        }
      );
      context.state.loading = false;
      return reponse.data.result;
    },
  };
  mutations = {
    setIsLoading(state: ReportState, isLoading: boolean) {
      state.loading = isLoading;
    },
  };
}
const reportModule = new ReportModule();
export default reportModule;
